import React from 'react';
import Actions from 'asset_level/components/list/AssetLevelActions';
import { translate } from 'react-i18next';
import { formatMoney } from 'accounting-js';

const AssetLevelListRow = ({ company, subcompany, permissions, asset_level, t, handleToggle }) => {
  return (
    <tr>
      <td>{asset_level.key}</td>
      <td>{asset_level.name}</td>
      <td>{asset_level.max_time}</td>
      <td className="text-center">
        {t(asset_level.message_required ? 'common.yes' : 'common.no')}
      </td>
      <td className="text-center">{t(asset_level.can_withdrawn ? 'common.yes' : 'common.no')}</td>
      <td>{asset_level.role_to_acept ? asset_level.role_to_acept.name : ''}</td>
      {/* <td>{formatMoney(asset_level.amount)}</td> */}
      <td className="text-center">{t(asset_level.active ? 'common.yes' : 'common.no')}</td>
      <td className="text-center">
        <Actions
          company={company}
          asset_level={asset_level}
          handleToggle={handleToggle}
          permissions={permissions}
          subcompany={subcompany}
        />
      </td>
    </tr>
  );
};

export default translate()(AssetLevelListRow);



// WEBPACK FOOTER //
// src/modules/secured/modules/asset_level/components/list/AssetLevelListRow.js